module.exports = __webpack_public_path__ + "static/media/kubb.6675dc3b.svg";